import { createSelector } from 'reselect';
import { getGdsServicesCalculatedCountInfoSelector } from '@shared/lib/gdsService/getGdsServicesCalculatedCountInfoSelector';
const getCheckinOrder = (state) => state.order;
const getAllServices = createSelector(getCheckinOrder, order => { var _a, _b, _c; return (_c = (_b = (_a = order.additionalServices) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services) !== null && _c !== void 0 ? _c : []; });
const getSegmentIds = createSelector(getCheckinOrder, order => { var _a, _b; return (_b = (_a = order.segments) === null || _a === void 0 ? void 0 : _a.map(segment => segment.id)) !== null && _b !== void 0 ? _b : []; });
const getTravellerIds = createSelector(getCheckinOrder, order => { var _a, _b; return (_b = (_a = order.travellers) === null || _a === void 0 ? void 0 : _a.map(traveller => traveller.id)) !== null && _b !== void 0 ? _b : []; });
const getServicesRestrictionsByType = createSelector(getCheckinOrder, order => { var _a, _b, _c; return (_c = (_b = (_a = order.additionalServices) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.servicesRestrictionsByType) !== null && _c !== void 0 ? _c : []; });
const getSelectedServices = (state) => state.selectedServices;
export const getGdsSelectedServicesCountInfo = createSelector(getAllServices, getSelectedServices, (gdsServices, selectedServices) => {
    const gdsServiceMap = new Map(gdsServices.map(service => [service.id, service]));
    const result = {};
    for (const passengerId in selectedServices) {
        const passengerServices = selectedServices[passengerId];
        for (const serviceId in passengerServices) {
            const services = passengerServices[serviceId];
            for (const segmentId in services) {
                const serviceInfo = gdsServiceMap.get(serviceId);
                if (!serviceInfo) {
                    console.warn(`Service ${serviceId} not found for ID: ${serviceId}`);
                    continue;
                }
                const rfisc = serviceInfo.rfisc;
                const type = serviceInfo.type;
                const selectedCount = services[segmentId];
                let subType;
                if (serviceInfo.baggageType) {
                    subType = serviceInfo
                        .baggageType;
                }
                if (serviceInfo.subType) {
                    subType = serviceInfo.subType;
                }
                // Initialize passenger entry if it doesn't exist
                if (!result[passengerId]) {
                    result[passengerId] = {
                        segments: {},
                        total: { rfisc: {}, type: {}, subType: {} }
                    };
                }
                if (!result[passengerId].segments[segmentId]) {
                    result[passengerId].segments[segmentId] = {
                        rfisc: {},
                        type: {},
                        subType: {}
                    };
                }
                // Update total rfisc count
                result[passengerId].total.rfisc[rfisc] =
                    (result[passengerId].total.rfisc[rfisc] || 0) + selectedCount;
                // Update total type count
                result[passengerId].total.type[type] = (result[passengerId].total.type[type] || 0) + selectedCount;
                // Update total subType count if subType exists
                if (subType) {
                    result[passengerId].total.subType[subType] =
                        (result[passengerId].total.subType[subType] || 0) + selectedCount;
                }
                // Update segment rfisc count
                result[passengerId].segments[segmentId].rfisc[rfisc] =
                    (result[passengerId].segments[segmentId].rfisc[rfisc] || 0) + selectedCount;
                // Update segment type count
                result[passengerId].segments[segmentId].type[type] =
                    (result[passengerId].segments[segmentId].type[type] || 0) + selectedCount;
                // Update segment subType count if subType exists
                if (subType) {
                    result[passengerId].segments[segmentId].subType[subType] =
                        (result[passengerId].segments[segmentId].subType[subType] || 0) + selectedCount;
                }
            }
        }
    }
    return result;
});
export const getGdsServicesCalculatedCountInfo = createSelector(getTravellerIds, getSegmentIds, getServicesRestrictionsByType, getGdsSelectedServicesCountInfo, getGdsServicesCalculatedCountInfoSelector);
